var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chatbot_2_",
    "data-name": "chatbot (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.407,
    height: 40.407,
    viewBox: "0 0 40.407 40.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_43886",
    "data-name": "Path 43886",
    d: "M2.595,272.66A3.557,3.557,0,0,0,0,276.08v4.735a3.558,3.558,0,0,0,2.581,3.416,11.445,11.445,0,0,1-.135-1.759c0-8.667-.006-8.141.016-8.568A11.322,11.322,0,0,1,2.595,272.66Z",
    transform: "translate(0 -251.142)",
    fill: "#387f75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43887",
    "data-name": "Path 43887",
    d: "M479.11,272.66a11.45,11.45,0,0,1,.149,1.842v7.971a11.446,11.446,0,0,1-.135,1.759,3.558,3.558,0,0,0,2.581-3.416V276.08A3.558,3.558,0,0,0,479.11,272.66Z",
    transform: "translate(-441.298 -251.142)",
    fill: "#387f75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43888",
    "data-name": "Path 43888",
    d: "M91.463,188.508H78.411L74.426,190.5a3.551,3.551,0,0,1-5.139-3.177V181.44A9.087,9.087,0,0,0,61,190.481v7.971a9.086,9.086,0,0,0,9.076,9.076H82.7a9.086,9.086,0,0,0,9.076-9.076v-7.971a9.06,9.06,0,0,0-.217-1.975C91.529,188.508,91.5,188.508,91.463,188.508Zm-19.809,5.919a1.184,1.184,0,1,1-2.368,0V192.06a1.184,1.184,0,1,1,2.368,0Zm7.1,5.919H74.022a1.184,1.184,0,1,1,0-2.368h4.735a1.184,1.184,0,1,1,0,2.368Zm4.735-5.919a1.184,1.184,0,0,1-2.368,0V192.06a1.184,1.184,0,1,1,2.368,0Z",
    transform: "translate(-56.186 -167.121)",
    fill: "#387f75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43889",
    "data-name": "Path 43889",
    d: "M5.735,97.9a3.551,3.551,0,1,0-2.368,0c0,2.178,0,3.8,0,5.018l.935-.268a11.489,11.489,0,0,1,1.433-2.433Z",
    transform: "translate(-0.921 -83.818)",
    fill: "#387f75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43890",
    "data-name": "Path 43890",
    d: "M215.809,0H201.13A5.136,5.136,0,0,0,196,5.13V20.2a1.184,1.184,0,0,0,1.713,1.059L202.2,19.02h13.611a5.136,5.136,0,0,0,5.13-5.13V5.13A5.136,5.136,0,0,0,215.809,0Zm-.868,13.1H202a1.184,1.184,0,0,1,0-2.368h12.943a1.184,1.184,0,0,1,0,2.368Zm0-4.735H202A1.184,1.184,0,0,1,202,6h12.943a1.184,1.184,0,0,1,0,2.368Z",
    transform: "translate(-180.532)",
    fill: "#387f75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.aeaeaf314161dd37572d8a99a118e237.svg";
export { ForwardRef as ReactComponent };